import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled';
import Error from './Error';  
import useMoneda from '../hooks/useMoneda';
import useCryptomoneda from '../hooks/useCryptomoneda';
import axios from 'axios';
   


const BotonSubmit = styled.button`
    width:100%;
    margin-top:20px;
    font-weight:bold;
    font-size:20px;
    padding:10px;
    background-color: #66A2FE;
    border: none;
    border-radius:10px;
    color: #fff;
    transition: background-color .3 easy;
    &:hover{
        background-color: #32AAC0; 
        cursor:pointer;
    }
`

const Formulario = ({guardarCriptomoneda, guardarMoneda}) => {

    const [listaCrypto , guardarCryptomoneda] = useState([]);
    const [error , guardarError] = useState(false);

    const MONEDA =[
        {codigo: 'USD', nombre : 'Dolar de Estados Unidos'},
        {codigo: 'PEN', nombre : 'Soles Peruanos'},
        {codigo: 'EUR', nombre : 'Euro'},
        {codigo: 'GBP', nombre : 'Libra esterlina'}
    ]
    // utilizar usemoneda
    const[moneda , SelectMoneda] = useMoneda('Elige tu moneda', '', MONEDA);

    // utilizar crypto

    const [cryptomoneda , SelectCrypto] = useCryptomoneda('Elige tu moneda', '',listaCrypto)

    // ejecuta llamado a la api

    useEffect(()=>{
        const consultarApi =  async() =>{
                const url ='https://min-api.cryptocompare.com/data/top/mktcapfull?limit=10&tsym=USD';
                const resultado = await axios.get(url);
                guardarCryptomoneda(resultado.data.Data);
        }
        consultarApi();
    }, []);

    const cotizarMoneda = e => {
        e.preventDefault();

        if(moneda === '' || cryptomoneda ==='')
        {
            guardarError(true);
            return;
        }
        guardarError(false);
        guardarCriptomoneda(cryptomoneda);
        guardarMoneda(moneda);
    }
    return (  
        <form onSubmit={cotizarMoneda}>
            {error ? <Error mensaje ="todos los campos debes ser seleccionados"/> : null}
            <SelectMoneda/>
            <SelectCrypto/>
            <BotonSubmit type="submit"
            >Calcular</BotonSubmit>
        </form>
    );
}
 
export default Formulario;